import React from "react";
import Header from "./Header";
import Footer from "./Footer";

class Biography extends React.Component {
  render() {
    return (
      <div>
        <Header />
        <div className="container">
          <h1 className="heading serif-font">Biography</h1>
          <p>
            It’s no surprise Estelle's life’s work is about beauty and fashion
            and fabulous things. She holds her stable of talent to the highest
            standards. She insures alignment between them and the creative teams
            they work with to craft unforgettably impactful images.
          </p>
          <p>
            Bewitching enough to lure Bert Stern out of retirement…(“He taught
            me a lot about art and had the greatest stories at dinner,” she
            says. “I miss him every day.”)
          </p>
          <p>
            Punk enough to drink coffee round the clock with Mick Rock…(“A
            legend in finding the soul of his subject matter.”)
          </p>
          <p>
            Estelle knows star quality talent when she sees it. Hers. Yours.
            When that’s blended into your own needs and vision, the results are
            pretty damn near perfect.
          </p>
          <p>
            She brings top tier talent and her own tenaciousness to projects.
            Her skill is to adroitly mesh a photographer’s or director’s
            strengths with the creative teams that hire them. She wants everyone
            on every shoot to feel like they’re doing the best work of their
            careers. And then a funny thing happens…they do.
          </p>
          <br />
          <p>***</p>
          <br />

          <p>
            “Estelle Leeds is the ultimate connector. Blessed with a killer eye
            for creative and craft,  she unites the right talents around the
            table to build a unified vision for any client. All of the above
            plus incredible drive and energy, as the kids say these days ---
            she`s a real one.”
          </p>
          <p>
            <strong>Mikki Brunner</strong>
          </p>
          <p>Worldwide ECD, Garnier</p>
          <p>Publicis Conseil</p>
          <br />
          <p>*</p>
          <br />

          <p>
            “Estelle brings a human touch to talent management. She has an
            innate sense of perfect pairings. She achieves both an artistic and
            personality match between talents and creatives which always ensures
            a successful outcome. It is comforting to work with a collaborator
            you trust implicitly.”
          </p>
          <p>
            <strong>Hans Dorsinville</strong>
          </p>
          <p>SVP global creative / Balmain beauty</p>
          <br />
          <p>*</p>
          <br />

          <p>
            “Estelle Leeds stands for GET IT DONE. A Very Strong , resourceful,
            powerful, creative, can-do agent. For my entire career I have seen
            estelle grow budding artists into full blown , established directors
            and photographers. She has an eye of a hawk and knows how to plow
            through all the good and bad of our business. She’s reliable, funny
            and always up for good fun between all the hard work. When you need
            something done, estelle leeds is the one to call. ”
          </p>
          <p>
            <strong>Jen Pugliese</strong>
          </p>
          <p>global head of production / Gotham agency </p>
          <br />
          <p>*</p>
          <br />
          <p>
            “Tastemaker. OG Influencer. Talent Connoisseur. Trailblazer. Estelle
            is all of these things, and a few more. She’s my ‘go-to’ for her
            fierce approach to connecting the most talented people with the
            coolest projects.”
          </p>
          <p>
            <strong>KELLY BROAD</strong>
          </p>
          <p>EXECUTIVE PRODUCER / HARBOR</p>
          <br />
          <p>*</p>
          <br />
          <p>
            “Estelle is a true force of fearlessness! Unapologetically bold, she
            breaks barriers for her talented tribe. A trailblazer who inspires
            with every step, she embodies the spirit of creativity and audacity
            delivered with humour and compassion.”
          </p>
          <p>
            <strong>PAUL EUSTACE</strong>
          </p>
          <p>EXECUTIVE CD / SAACHI & SAACHI </p>
          <br />
          <p>*</p>
          <br />
          <p>
            “She sets the bar high and wields her ballsy charm like a siren.
            Estelle has the uncanny ability to make herself the passionate
            fulcrum for creativity.”
          </p>
          <p>
            <strong>MARK FINA</strong>
          </p>
          <p>GLOBAL CREATIVE / ESTÉE LAUDER AVEDA </p>
          <br />
          <p>*</p>
          <br />
          <p>
            “Throw Estelle to the lions and she will appear later wearing their
            coats.”
          </p>
          <p>
            <strong>BERT STERN</strong>
          </p>
          <p>Photographer</p>
          <br />
          <p>*</p>
          <br />
          <p>
            “Estelle has a superb creative eye, is unfailingly professional,
            unfazed by anything, makes shit happen, and is enormous fun to hang
            out with.”
          </p>
          <p>
            <strong>CINDY GALLOP</strong>
          </p>
          <p>Founder, MakeLoveNotPorn</p>
          <p>Founder and CEO If We Ran The World</p>
          <br />
          <p>*</p>
          <br />
          <p>
            "Gorgeous, vibrant, Estelle fills the room with the sense of
            brilliant possibilities."
          </p>
          <p>
            <strong>VERONIQUE GABAI</strong>
          </p>
          <p>CCO / President </p>
          <p>Veronique Gabai Fragrances </p>

          <br />
          <p>*</p>
          <br />
          <p>
            “One word to describe Estelle is her “passion” for this business.
            But one word will never be enough, so I will add
            smart…dedicated…with unique British wit.”
          </p>
          <p>
            <strong>MARC BENHAMOU</strong>
          </p>
          <p>Founder and creative director</p>
          <p>Creative 360°</p>
          <br />
          <p>*</p>
        </div>
        <Footer />
      </div>
    );
  }
}

export default Biography;
